export const APP_LANGUAGES = {
  ar: "العربية",
  en: "English",
};

export const APP_TEXT = {
  ar: {
    nav: {
      companies: "الشركات",
      pricing: "التسعير",
      suppliers: "الموردين",
      settings: "الإعدادات",
    },
    login: {
      hero: "Know Costs - Beat The Market",
      login: "تسجيل الدخول",
      register: "إنشاء حساب",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      fullName: "الاسم الكامل",
      confirmPassword: "تأكيد كلمة المرور",
      submitLogin: "تسجيل الدخول",
      submitRegister: "إنشاء حساب والمتابعة",
      guest: "الدخول كضيف",
      registerHint:
        "يمكنك إنشاء حساب لمزامنة بياناتك، مع بقاء كل الأدوات متاحة للجميع.",
      loginHint:
        "تسجيل الدخول يفتح لك كل صلاحيات التطبيق وإدارة المشاريع بالكامل.",
      guestHint:
        "وضع الضيف يفتح لك كامل أدوات التسعير والشركات والموردين مباشرة.",
    },
    pages: {
      companies: {
        eyebrow: "الشركات",
        title: "إدارة الشركات والعملاء",
        description:
          "استعرض الشركات والمقاولين، اختر المشروع المناسب للتسعير، وأنشئ شركات أو مشاريع جديدة داخل نفس التجربة.",
      },
      pricing: {
        eyebrow: "التسعير",
        title: "تحليل وتسعير بنود المقاولات",
        description:
          "اختر البند، حلل التكاليف المباشرة وغير المباشرة، أضف الربح، وقارن السعر مع السوق للوصول إلى قرار أسرع وأدق.",
      },
      suppliers: {
        eyebrow: "الموردين",
        title: "دليل الموردين وعروض الأسعار",
        description:
          "اعرض الموردين المرتبطين بالسوق، وافتح بياناتهم، وقارن بينهم للوصول إلى أفضل جهة توريد لكل بند.",
      },
      settings: {
        eyebrow: "الإعدادات",
        title: "إعدادات الحساب والتسعير",
        description:
          "تابع الحساب وراجع مصدر البنود المستوردة وتوزيعها على أقسام التسعير داخل التطبيق.",
      },
    },
    settings: {
      account: "الحساب",
      source: "مصدر البيانات",
      guest: "زائر",
      browseMode: "وضع الاستعراض",
      profile: "الملف الشخصي",
      language: "اللغة",
      languageSwitch: "تغيير اللغة",
      notifications: "الإشعارات",
      support: "الدعم",
      technicalSupport: "الدعم الفني",
      privacy: "سياسة الخصوصية",
      contact: "تواصل معنا",
      update: "تحديث التطبيق",
      rate: "تقييم التطبيق",
      appearance: "المظهر",
      darkMode: "داكن",
      lightMode: "فاتح",
      appInfo: "معلومات التطبيق",
      version: "الإصدار",
      disclaimer: "هذا التطبيق غير تابع لأي جهة حكومية.",
      reviewMarket: "استعراض السوق",
      learnPricing: "التعرف على التسعير",
      registerAccount: "تسجيل حساب",
      guestHint:
        "أنت داخل كتجربة ضيف. يمكنك التنقل والاطلاع على البنود والأسعار والموردين واستخدام الأدوات بدون قيود.",
      logout: "تسجيل الخروج",
      languageTitle: "تغيير اللغة",
      accessTitle: "وصول كامل",
      accessSubtitle: "كل المستخدمين والضيوف لديهم نفس الوصول.",
      manageCompanies: "إدارة الشركات",
      managePricing: "إدارة التسعير",
      manageSuppliers: "إدارة الموردين",
      importCurrent: "مصدر البنود الحالي",
      lastUpdate: "آخر تحديث",
      market: "السوق",
      currency: "العملة",
      itemCount: "عدد البنود",
      distribution: "توزيع البنود حسب القسم",
      nextImport:
        "الخطوة التالية ستكون إضافة زر استيراد ملف جديد، مع اختيار السوق والعملة قبل إدخال البنود إلى النظام.",
      updateStatus: "أنت على آخر إصدار متاح حاليًا.",
      contactValue: "walidghazal46@gmail.com",
      supportValue: "الرد خلال ساعات العمل من داخل البريد.",
      privacyBody:
        "نحفظ بيانات الاستخدام الأساسية داخل التطبيق لتحسين تجربة التسعير، ولا تتم مشاركة بياناتك مع أي جهة خارجية دون موافقة واضحة منك.",
      rateBody:
        "يمكنك تقييم التطبيق بعد تسجيل الدخول ومشاركة تجربتك لمساعدة الفريق على تحسين الأداء والدقة.",
      loginNow: "تسجيل الدخول الآن",
      createAccountNow: "إنشاء حساب",
      switchAccount: "تبديل الحساب",
      sessionStatus: "حالة الجلسة",
      signedInAs: "مسجل الدخول باسم",
      signedInAt: "آخر دخول",
      guestSession: "أنت الآن في وضع الضيف",
      guestSessionBody: "يمكنك تسجيل الدخول أو إنشاء حساب من داخل التطبيق في أي وقت.",
    },
    common: {
      close: "إغلاق",
      save: "حفظ",
    },
  },
  en: {
    nav: {
      companies: "Companies",
      pricing: "Pricing",
      suppliers: "Suppliers",
      settings: "Settings",
    },
    login: {
      hero: "Know Costs - Beat The Market",
      login: "Log In",
      register: "Create Account",
      email: "Email",
      password: "Password",
      fullName: "Full name",
      confirmPassword: "Confirm password",
      submitLogin: "Log In",
      submitRegister: "Create Account",
      guest: "Continue as Guest",
      registerHint:
        "Create an account to sync your data while every tool remains open to everyone.",
      loginHint:
        "Logging in unlocks full application access and complete project management.",
      guestHint:
        "Guest mode opens the full pricing, companies, and suppliers experience immediately.",
    },
    pages: {
      companies: {
        eyebrow: "COMPANIES",
        title: "Company And Client Management",
        description:
          "Browse contractors and consultants, pick the right project for pricing, and create new companies or projects in one flow.",
      },
      pricing: {
        eyebrow: "PRICING",
        title: "Construction Cost Analysis",
        description:
          "Choose an item, analyze direct and indirect costs, add profit, and compare against market pricing faster.",
      },
      suppliers: {
        eyebrow: "SUPPLIERS",
        title: "Supplier Directory And Quotes",
        description:
          "Review market-linked suppliers, open their details, and compare them to choose the right source for each item.",
      },
      settings: {
        eyebrow: "SETTINGS",
        title: "Account And Pricing Settings",
        description:
          "Review account details and imported pricing sources across the app.",
      },
    },
    settings: {
      account: "Account",
      source: "Data Source",
      guest: "Guest",
      browseMode: "Browse mode",
      profile: "Profile",
      language: "Language",
      languageSwitch: "Switch language",
      notifications: "Notifications",
      support: "Support",
      technicalSupport: "Technical support",
      privacy: "Privacy policy",
      contact: "Contact us",
      update: "App update",
      rate: "Rate the app",
      appearance: "Appearance",
      darkMode: "Dark",
      lightMode: "Light",
      appInfo: "App info",
      version: "Version",
      disclaimer: "This app is not affiliated with any government entity.",
      reviewMarket: "Review market",
      learnPricing: "Learn pricing",
      registerAccount: "Create account",
      guestHint:
        "You are browsing as a guest. You can review items, prices, suppliers, and use all tools without restrictions.",
      logout: "Log Out",
      languageTitle: "Language",
      accessTitle: "Full access",
      accessSubtitle: "All users and guests have the same access.",
      manageCompanies: "Manage companies",
      managePricing: "Manage pricing",
      manageSuppliers: "Manage suppliers",
      importCurrent: "Current source",
      lastUpdate: "Last update",
      market: "Market",
      currency: "Currency",
      itemCount: "Items",
      distribution: "Items by category",
      nextImport:
        "Next step: add a new import button with market and currency selection before loading items into the system.",
      updateStatus: "You are currently using the latest available version.",
      contactValue: "walidghazal46@gmail.com",
      supportValue: "Support replies are handled during working hours through the app and email.",
      privacyBody:
        "We keep essential in-app usage data to improve pricing workflows and never share your data externally without clear consent.",
      rateBody:
        "You can rate the application after signing in and leave feedback to improve quality and pricing accuracy.",
      loginNow: "Log in now",
      createAccountNow: "Create account",
      switchAccount: "Switch account",
      sessionStatus: "Session status",
      signedInAs: "Signed in as",
      signedInAt: "Last sign-in",
      guestSession: "You are currently browsing as a guest",
      guestSessionBody: "You can log in or create an account from inside the app at any time.",
    },
    common: {
      close: "Close",
      save: "Save",
    },
  },
};

export function getAppText(language = "ar") {
  return APP_TEXT[language] || APP_TEXT.ar;
}
